import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"400"},model:{value:(_vm.modalProp),callback:function ($$v) {_vm.modalProp=$$v},expression:"modalProp"}},[_c(VCard,[_c(VCardTitle,{staticClass:"headline green accent-4 white--text elevation-7"},[_vm._v(" Account Validation ")]),_c('div',{staticStyle:{"width":"80%","margin":"auto"}},[_c(VCardText,{staticClass:"my-5 text-center subtitle-2"},[_vm._v(" "+_vm._s(_vm.status)+" ")])],1),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"red darken-1","text":""},on:{"click":function($event){_vm.modalProp = false}}},[_vm._v(" Close ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }